export const freezeBody = (doFreeze, scrollToTop = true) => {
  const body = document.body;

  body.classList.toggle('_freeze', doFreeze);
  if (doFreeze) {
    body.style.top = `-${window.scrollY}px`;
    body.style.position = 'fixed';
    return;
  }
  const scrollToY = Math.abs(body.getBoundingClientRect().top);
  body.removeAttribute('style');

  if (scrollToTop) {
    window.scrollTo(0, 0);
  } else {
    window.scrollTo(0, scrollToY);
  }
};

export const getScrollBarWidth = () => {
  const outer = document.createElement('div');

  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.msOverflowStyle = 'scrollbar';

  document.body.appendChild(outer);

  const inner = document.createElement('div');

  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
};
